import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import SingleDay from './SingleDay';
import DayAvailableHours from './DayAvailableHours';
import { useMediaQuery } from '../../../utilities/hooks/useMediaQuery';
import './timeSlots.scss';
SwiperCore.use([Pagination, Navigation]);

const VISIBLE_DATES_COUNT = 4;
const DATE_CARD_WIDTH = 96;
const DATE_GAP = 12;
const DATES_TRACK_WIDTH = VISIBLE_DATES_COUNT * DATE_CARD_WIDTH + (VISIBLE_DATES_COUNT - 1) * DATE_GAP;
const arrowRightIcon = require('./icons/arrow-right.svg').default || require('./icons/arrow-right.svg');
const arrowLeftIcon = require('./icons/arrow-left.svg').default || require('./icons/arrow-left.svg');

const TimeSlots = (props) => {
  const [swiper, setSwiper] = useState();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const isMobile = useMediaQuery('(max-width: 480px)');
  const datesCount = props.technicianTimes?.length ?? 0;
  const showFourSlides = datesCount >= VISIBLE_DATES_COUNT;
  const slidesPerView = isMobile ? 'auto' : showFourSlides ? VISIBLE_DATES_COUNT : Math.max(datesCount, 1);
  const showNavigation = datesCount > 0 && !isMobile;
  useEffect(() => {
    if (!swiper) {
      return;
    }

    swiper.params.slidesPerView = slidesPerView;
    swiper.update();

    if (showNavigation) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    } else if (swiper.navigation) {
      swiper.navigation.destroy();
    }
  }, [swiper, showNavigation, slidesPerView]);

  const onDayClick = (day) => {
    props.onSelectDay(day);
  };

  return (
    <div className='time-slots-wrapper'>
      <div className={`time-slots-components ${showNavigation ? 'time-slots-components--with-nav' : ''}`}>
        {showNavigation && (
          <button type='button' className='time-slots-nav swiper-button-prev' ref={prevRef}>
            <img src={arrowRightIcon} alt='' />
          </button>
        )}
        <div
          className='time-slots-dates-track'
          style={{ width: showFourSlides && !isMobile ? DATES_TRACK_WIDTH : undefined }}>
          <Swiper
            style={{ height: '64px', width: '100%' }}
            modules={[Navigation]}
            navigation={showNavigation ? { prevEl: prevRef.current, nextEl: nextRef.current } : false}
            watchOverflow={true}
            loop={false}
            spaceBetween={DATE_GAP}
            slidesPerView={slidesPerView}
            className={datesCount < VISIBLE_DATES_COUNT ? 'center-slots-slides' : ''}
            centeredSlides={false}
            centeredSlidesBounds={false}
            slideToClickedSlide={true}
            centerInsufficientSlides={datesCount < VISIBLE_DATES_COUNT}
            onSwiper={setSwiper}>
            {props.technicianTimes?.map((item, index) => (
              <SwiperSlide onClick={() => onDayClick(item, index)} key={index}>
                <SingleDay
                  dayOfWeek={item.dayOfWeek}
                  month={item.month}
                  day={item.day}
                  monthName={item.monthName}
                  hours={item.hours}
                  isSelected={item.isSelected}
                  index={index}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {showNavigation && (
          <button type='button' className='time-slots-nav swiper-button-next' ref={nextRef}>
            <img src={arrowLeftIcon} alt='' />
          </button>
        )}
      </div>
      <div className='hours-map'>
        {props.technicianTimes?.map(
          (item, index) => item.isSelected && <DayAvailableHours item={item} key={index} onSelectHours={props.onSelectHours} />
        )}
      </div>
    </div>
  );
};

export default TimeSlots;
